import React from 'react';
import { FullScreenOverlay } from '../FullScreenOverlay';
import {
  UpgradeConfirmationBodyWrapper,
  UpgradeConfirmationHeader,
  UpgradeConfirmationDescription,
  ButtonGroupWrapper,
  CancelButton,
  BoldText,
} from './UpgradeConfirmationPopupStyles';
import OrangeButton from '../OrangeButton';

export const UpgradeConfirmationPopup = ({ onCancel, onProceed }) => {
  return (
    <FullScreenOverlay onClickOutside={onCancel}>
      <UpgradeConfirmationBodyWrapper>
        <UpgradeConfirmationHeader>You are about to upgrade your plan!</UpgradeConfirmationHeader>
        <UpgradeConfirmationDescription>
          By clicking <BoldText>Confirm</BoldText>, you agree to proceeding with the payment and
          changing your plan.
        </UpgradeConfirmationDescription>
        <ButtonGroupWrapper>
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
          <OrangeButton onClick={onProceed}>Confirm</OrangeButton>
        </ButtonGroupWrapper>
      </UpgradeConfirmationBodyWrapper>
    </FullScreenOverlay>
  );
};
